// extracted by mini-css-extract-plugin
export default {"expandDescriptionArea":"expandDescriptionArea--AaJQY","expandDescriptionSparks":"expandDescriptionSparks--DGgyf","expandIcon":"expandIcon--NNYpI"};